import styles from '../styles.module.scss';
import cn from 'classnames';
import { forwardRef, InputHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: FieldError;
  additionalClass?: string;
  isSmallSize?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ error, additionalClass = '', isSmallSize = false, ...rest }, ref) => (
    <input
      ref={ref}
      type="text"
      className={cn('form-control form-control-solid', additionalClass, {
        [styles.invalidInput]: error?.message,
        'form-control-sm': isSmallSize
      })}
      {...rest}
    />
  )
);

TextInput.displayName = 'TextInput';
